import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Matt Stayner
 * id B3A70192-FB1E-4CC9-AA89-44AD6C921BCE
 * name arrow-left-thin
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-thin.svg
 * tags
 * - Arrow 
 */
export const ArrowLeftThinIcon = createSvgIcon(<><path d="M10.05 16.94V12.94H18.97L19 10.93H10.05V6.94L5.05 11.94Z" /></>, 'ArrowLeftThinIcon');
export default ArrowLeftThinIcon